

interface AppSettings {
    APP_Name: string; //--Denumire Aplicatie
    APP_Version: string;//--Versiune Aplicatie
    APP_Color: string;//--Culoarea Aplicatie
    API_Url: string; //--URL API
    API_Url_Comercial: string; //--URL API Comercial
    API_Url_ComercialUpload: string; //--URL API Comercial
    API_Url_Contabilitate: string; //--URL API Contabilitate
    API_Url_ContabilitateRest: string; //--URL API Contabilitate REST
    API_Url_ResurseUmane: string; //--URL API Contabilitate
    API_Url_ResurseUmaneOdata: string; //--URL API Contabilitate
    API_Url_ComercialOdata: string; //--URL API Comercial
    API_Url_Documente: string; //--URL API Documente
    API_Url_DocumenteOdata: string; //--URL API Documente
    API_Url_Rapoarte: string; //--URL API Rapoarte
    API_Url_RapoarteOdata: string; //--URL API Rapoarte
    API_Url_ComercialSignalR: string; //--URL API Rapoarte
    API_Url_AuthSignalR: string; //--URL hub central notificari platforma (mentenanta)
    API_Url_Anaf: string; //--URL API ANAF
    API_Url_AuthOdata: string; //--URL API Auth OData
    API_Url_Financiar: string; //--URL API Financiar
    API_Url_FinanciarOdata: string; //--URL API Financiar OData
    API_Url_StocareDocumente: string; //--URL API Stocare Documente
    API_Url_Edi: string; //--URL API EDI Integration
    API_Url_PortalHR: string; //--URL API Portal HR
    API_Url_PortalHROdata: string; //--URL API Portal HR OData
    API_Url_Medical: string; //--URL API Medical
    API_Url_MedicalOdata: string; //--URL API Medical OData
    API_Url_Stocuri: string; //--URL API Stocuri
    API_Url_StocuriOdata: string; //--URL API Stocuri OData
    API_Url_ParcAuto: string; //--URL API Parc Auto
    API_Url_ParcAutoOdata: string; //--URL API Parc Auto OData
    API_Url_Contracte: string; //--URL API Contracte
    API_Url_ContracteOdata: string; //--URL API Contracte OData
    APP_Timezone: string; //offset-ul de adaugat la data in cazul filtrarilor

}

/**
 * All app params for UI.
 */
const DefaultSetting: AppSettings = {
    APP_Name: 'ERA',
    APP_Version: "26.08.04.2",
    APP_Color: 'red darken-1',

    API_Url: process.env.VUE_APP_API_URL,
    API_Url_Comercial: process.env.VUE_APP_API_URL_COMERCIAL,
    API_Url_ComercialUpload: process.env.VUE_APP_API_URL_COMERCIAL_UPLOAD,
    API_Url_Contabilitate: process.env.VUE_APP_API_URL_CONTABILITATE,
    API_Url_ContabilitateRest: process.env.VUE_APP_API_URL_CONTABILITATE_REST,
    API_Url_ResurseUmane: process.env.VUE_APP_API_URL_RESURSEUMANE,
    API_Url_ResurseUmaneOdata: process.env.VUE_APP_API_URL_RESURSEUMANE_ODATA,
    API_Url_ComercialOdata: process.env.VUE_APP_API_URL_COMERCIAL_ODATA,
    API_Url_Documente: process.env.VUE_APP_API_URL_DOCUMENTE,
    API_Url_DocumenteOdata: process.env.VUE_APP_API_URL_DOCUMENTE_ODATA,
    API_Url_Rapoarte: process.env.VUE_APP_API_URL_RAPOARTE,
    API_Url_RapoarteOdata: process.env.VUE_APP_API_URL_RAPOARTE_ODATA,
    API_Url_ComercialSignalR: process.env.VUE_APP_API_URL_COMERCIAL_SIGNALR,
    API_Url_AuthSignalR: process.env.VUE_APP_API_URL_AUTH_SIGNALR,
    API_Url_Anaf: process.env.VUE_APP_API_URL_COMERCIAL,
    API_Url_AuthOdata: process.env.VUE_APP_API_URL_AUTH_ODATA,
    API_Url_Financiar: process.env.VUE_APP_API_URL_FINANCIAR,
    API_Url_FinanciarOdata: process.env.VUE_APP_API_URL_FINANCIAR_ODATA,
    API_Url_StocareDocumente: process.env.VUE_APP_API_URL_STOCARE_DOCUMENTE,
    API_Url_Edi: process.env.VUE_APP_API_URL_EDI,
    API_Url_PortalHR: process.env.VUE_APP_API_URL_PORTALHR,
    API_Url_PortalHROdata: process.env.VUE_APP_API_URL_PORTALHR_ODATA,
    API_Url_Medical: process.env.VUE_APP_API_URL_MEDICAL,
    API_Url_MedicalOdata: process.env.VUE_APP_API_URL_MEDICAL_ODATA,
    API_Url_Stocuri: process.env.VUE_APP_API_URL_STOCURI,
    API_Url_StocuriOdata: process.env.VUE_APP_API_URL_STOCURI_ODATA,
    API_Url_ParcAuto: process.env.VUE_APP_API_URL_PARCAUTO,
    API_Url_ParcAutoOdata: process.env.VUE_APP_API_URL_PARCAUTO_ODATA,
    API_Url_Contracte: process.env.VUE_APP_API_URL_CONTRACTE,
    API_Url_ContracteOdata: process.env.VUE_APP_API_URL_CONTRACTE_ODATA,
    APP_Timezone: '+02:00',
};


export default DefaultSetting








